<template>
  <v-dialog
    v-model="dialog"
    :max-width="350"
    content-class="rounded-0"
    :retain-focus="false"
    @click:outside="escape(closeDialog)"
    @keydown.esc="escape(closeDialog)"
  >
    <v-card tile>
      <v-card-title>
        {{ title }}
        <p-btn-icon
          type="close"
          btn-class="mr-n3 ml-auto"
          tabindex="4"
          @click="escape(closeDialog)"
        ></p-btn-icon>
      </v-card-title>

      <v-card-text class="pb-2">
          <v-form ref="form" @submit.stop.prevent>
            <v-text-field
              v-if="requireName"
              v-model.trim="placeholder.name"
              :rules="rules.placeholderName"
              :label="$t('contractTemplate.placeholder.name')"
              :messages="$t('contractTemplate.placeholder.nameHint')"
              autocomplete="on"
              name="placeholderName"
              color="pink"
              class="p-clearable-on-hover"
              tabindex="1"
              clearable
              autofocus
            ></v-text-field>
            <v-autocomplete
              v-model.trim="placeholder.key"
              :items="keys"
              :rules="rules.key"
              :label="$t('contractTemplate.placeholder.key')"
              color="pink"
              class="p-clearable-on-hover"
              tabindex="1"
              clearable
            ></v-autocomplete>
            <v-text-field
              v-model.trim="placeholder.defaultValue"
              :label="$t('contractTemplate.placeholder.defaultValue')"
              color="pink"
              class="p-clearable-on-hover"
              tabindex="1"
              clearable
            ></v-text-field>
          </v-form>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn text tabindex="2" color="pink" @click="submit">{{ $t('ok') }}</v-btn>
        <v-btn text tabindex="3" @click="closeDialog">{{ $t('cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import placeholderHelper from '@/helpers/contractPlaceholder.helper'

import PBtnIcon from '@/components/PBtnIcon'

import dialogMixin from '@/mixins/dialog.mixin'
import validationMixin from '@/mixins/validation.mixin'
import unsavedChangesMixin from '@/mixins/unsavedChanges.mixin'


export default {
  components: {
    PBtnIcon
  },


  mixins: [
    dialogMixin,
    validationMixin,
    unsavedChangesMixin
  ],


  props: {
    keys: {
      type: Array
    },
    requireName: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    }
  },


  data () {
    return {
      placeholder: { }
    }
  },


  computed: {
    rulesToApply () {
      const rule = this.rule
      const placeholderName = this.requireName ? [rule.required()] : []

      return {
        placeholderName,
        key: [rule.required()]
      }
    }
  },


  methods: {
    onDialogOpen () {
      this.existingPlaceholderNames = []
      this.placeholder = {
        name: '',
        key: '',
        defaultValue: null
      }
      this.initWatchedModel(this.placeholder)
      this.resetValidation()
    },

    async submit () {
      const valid = await this.validate(this.rulesToApply)
      if (!valid || !this.isModelChanged()) return

      const placeholder = placeholderHelper.formatPlaceholder(this.placeholder)
      this.$emit('insert', placeholder)
      this.closeDialog()
    }
  }
}
</script>
